import type { ThemeConfig } from "antd";

const theme: ThemeConfig = {
  token: {
    fontSize: 16,
    fontFamily: "Inter, sans-serif",
    colorPrimary: "#4a6fff",
  },
};

export default theme;
